import * as _ from 'lodash';

/**
 * @description 事務所郵便番号
 */

export const POSTALCODE_KEY = {
  DISTRICT: { index: 0, key: 'district' },
  AREA: { index: 1, key: 'area' },
};

export const PostalCodeValue = () => {
  let postal_code = {
    district: '',
    area: '',
  };

  let callbacks = [];

  //個々に保持
  const set = (key, value) => {
    postal_code[key] = value;
    _.each(callbacks, callback => {
      callback(postal_code);
    });
  };

  //全部保持
  const setAll = value => {
    if (!value) {
      postal_code.district = '';
      postal_code.area = '';
      _.each(callbacks, callback => {
        callback(postal_code);
      });
      return;
    }
    const _code = value.split('-');
    postal_code.district = _code[0];
    postal_code.area = _code[1];
    _.each(callbacks, callback => {
      callback(postal_code);
    });
  };

  const get = key => {
    return postal_code[key];
  };

  const getAll = () => {
    if (postal_code.district === '' && postal_code.area === '') {
      return '';
    }
    return `${postal_code.district}-${postal_code.area}`;
  };

  const subscribe = func => {
    callbacks.push(func);
  };

  return {
    set,
    setAll,
    get,
    getAll,
    subscribe,
  };
};



// WEBPACK FOOTER //
// ./src/utilities/PostalCodeStore.js